import { loadEnvConfig } from '_/env-config';

(async () => {
  // First load the env/config.json file so we know which environment we are in.
  await loadEnvConfig();

  // Initialize i18n before booting the application
  const { i18nInitPromise } = await import(
    /* webpackChunkName: "i18n" */ '_/i18n'
  );
  await i18nInitPromise;

  // After loading the env/config.json boot the application.
  await import('_/app/app-boot');
})();
